var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.authorized)?[_c('top-bar'),_c('v-content',{staticClass:"light-grey-bg"},[_c('router-view')],1)]:[_c('v-content',{staticClass:"primary-bg"},[_c('router-view')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }